{
  "name": "oauth2",
  "version": "1.2.0",
  "browser": {
    "fs": false,
    "path": false,
    "os": false
  },
  "scripts": {
    "ng": "ng",
    "start": "ng serve --port=9200 --hmr=false --host 0.0.0.0 --open",
    "build": "ng build --configuration=production --aot=true --optimization=true",
    "build:stag": "ng build --configuration=stag --aot=true --optimization=true",
    "test": "ng test",
    "update-angular": "ng update @angular/core @angular/cli @angular/cdk @angular/compiler-cli @angular/material",
    "changelog-version": "node generate-changelog-update-version.js",
    "commit-version": "git add . && git commit -m'Version name: '$(grep -m1 version package.json | awk -F: '{ print $2 }' | sed 's/[\", ]//g')''",
    "release": "npm run changelog-version && npm run commit-version && git pull --rebase && git push && git checkout main && git pull  && git merge --no-ff --no-edit dev && git push && git checkout -",
    "update-sira-components": "npm install @marsaude/sira-components",
    "update-tokens": "npm install @marsaude/tokens",
    "update-design-system": "npm install @marsaude/sira-components @marsaude/tokens",
    "cypress:open": "cypress open",
    "cypress:run": "cypress run"
  },
  "private": true,
  "dependencies": {
    "@amplitude/analytics-browser": "^2.35.0",
    "@amplitude/experiment-js-client": "^1.20.3",
    "@angular/animations": "^21.1.4",
    "@angular/cdk": "^21.1.5",
    "@angular/common": "^21.1.4",
    "@angular/compiler": "^21.1.4",
    "@angular/core": "^21.1.4",
    "@angular/forms": "^21.1.4",
    "@angular/material": "^21.1.5",
    "@angular/platform-browser": "^21.1.4",
    "@angular/platform-browser-dynamic": "^21.1.4",
    "@angular/router": "^21.1.4",
    "@marsaude/sira-components": "^1.2.0",
    "@marsaude/tokens": "^1.0.4",
    "@ngx-formly/core": "^7.1.0",
    "@ngx-formly/material": "^7.1.0",
    "@sentry/angular": "^10.39.0",
    "@sentry/cli": "^3.2.0",
    "@tailwindcss/postcss": "^4.2.0",
    "@types/numeral": "^2.0.5",
    "@types/pdfjs-dist": "^2.10.378",
    "async-mutex": "^0.5.0",
    "browserslist": "^4.28.1",
    "dayjs": "^1.11.19",
    "express": "^5.2.1",
    "json-logic-js": "^2.0.5",
    "libheif-js": "^1.19.8",
    "lottie-web": "^5.13.0",
    "marked": "^17.0.3",
    "mime": "^4.1.0",
    "ng2-currency-mask": "^13.0.3",
    "ngx-captcha": "^14.0.0",
    "ngx-file-drop": "^16.0.0",
    "ngx-image-cropper": "^9.1.6",
    "ngx-lottie": "^21.2.0",
    "ngx-mask": "^21.0.1",
    "numeral": "^2.0.6",
    "path": "^0.12.7",
    "path-to-regexp": "^8.3.0",
    "pdfjs-dist": "^5.4.530",
    "rxjs": "^7.8.2",
    "swiper": "^12.1.2",
    "tailwindcss": "^4.2.0",
    "tslib": "^2.8.1",
    "zone.js": "~0.16.0"
  },
  "devDependencies": {
    "@angular/build": "^21.1.4",
    "@angular/cli": "~21.1.4",
    "@angular/compiler-cli": "^21.1.4",
    "@types/json-logic-js": "^2.0.8",
    "@types/node": "^25.2.3",
    "@types/w3c-image-capture": "^1.0.11",
    "cypress": "^15.10.0",
    "fflate": "^0.8.2",
    "material-symbols": "^0.40.2",
    "postcss": "^8.5.6",
    "semver": "^7.7.4",
    "start-server-and-test": "^2.1.3",
    "typescript": "~5.9.3",
    "zstd-codec": "^0.1.5"
  }
}